import React, {useContext} from 'react';
import PropTypes from 'prop-types';

//Context
import AppDataContext from '../../context/AppDataContext';

function GalleryPreview({imageUrl, imageAlt, numArt, onGalleryClick}) {
  const {getLocalizedString} = useContext(AppDataContext);

  return (
    <>
      <div className="gallery-preview">
        <div className="image-container">
          <img src={imageUrl} alt={imageAlt} />  
        </div>
        <div className="gallery-cta">
          <p className="images-counter">{numArt + ' ' + ((numArt <= 1) ? getLocalizedString('label_image') : getLocalizedString('label_images'))}</p>
          <button onClick={onGalleryClick}>{getLocalizedString('gallery_preview_open')}</button>
        </div>
      </div>
    </>
  );
}

GalleryPreview.propTypes = {
  artId: PropTypes.string.isRequired,
  galleryId: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  numArt: PropTypes.number.isRequired,
  onGalleryClick: PropTypes.func
};

export default GalleryPreview;